// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"f74908fa","152":"7652e494","165":"e9e43696","364":"8230d2bc","453":"6273327a","614":"2f34fe4c","790":"38bf9209"}[chunkId] + ".chunk.js";
};